import React from 'react';
import MeasurementUnitsBody from './body.tsx';
import MeasurementUnitsHeader from './header.tsx';
import { MeasurementUnitsContextProvider } from '../../../contexts/measurementUnits/measurementUnits.tsx';
import { AccessProvider } from '../../../contexts/accessProvider.tsx';
import { Role } from '../../../models/enums/role.ts';

const MeasurementUnits = () => {
    return (
        <AccessProvider roles={[Role.superAdmin]}>
            <MeasurementUnitsContextProvider>
                <MeasurementUnitsHeader />
                <MeasurementUnitsBody />
            </MeasurementUnitsContextProvider>
        </AccessProvider>
    );
};

export default MeasurementUnits;
